














import Vue from "vue";

export default Vue.extend({
  name: "OpenDialog",
  data: () => ({
    copied: false,
  }),
  methods: {
    addBoard: function() {
      this.$store.dispatch('addNewBoard');
      // TODO apply proper closing solution
      (this.$parent.$parent.$parent as any).closeDialog()
    }
  }
});
